'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Spinner } from '@common/components';
import { useToast } from '@common/hooks';
import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useInView } from 'react-intersection-observer';
import { AuthInfiniteQueryOptions, AuthMutation, UnauthInfiniteQueryOptions } from '@/api';
import { useLoginGuard } from '@/hooks/useLoginGuard';
import { useAuthStore } from '@/stores/AuthStore';
import { filledInfiniteQueryOptions } from '@/utils/filledInfiniteQueryOptions';
import { Comment } from './_components/Comment';
import { CommentForm } from './_components/CommentForm';
const INITIAL_PAGE = 1;
const INITIAL_SIZE = 20;
interface TabContentCommentsProps {
  donationBusinessId: number;
}

/**
 * * 지정기부사업상세 - 응원하기 탭
 */
export const TabContentComments = t0 => {
  const $ = _c(65);
  const {
    donationBusinessId
  } = t0;
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  const isLogin = useAuthStore(_temp);
  const loginGuard = useLoginGuard();
  let t1;
  if ($[0] !== donationBusinessId || $[1] !== isLogin) {
    t1 = filledInfiniteQueryOptions(isLogin ? AuthInfiniteQueryOptions["get:/wello/v2/auth/home/donation-business-comment"]({
      query: {
        donationBusinessId,
        page: INITIAL_PAGE,
        size: INITIAL_SIZE
      }
    }) : UnauthInfiniteQueryOptions["get:/wello/v2/allows/home/donation-business-comment"]({
      query: {
        page: INITIAL_PAGE,
        size: INITIAL_SIZE,
        donationBusinessId
      }
    }));
    $[0] = donationBusinessId;
    $[1] = isLogin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isLogin !== undefined;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isPending: isListPending
  } = useInfiniteQuery(t3);
  let t4;
  if ($[6] !== fetchNextPage || $[7] !== isFetching) {
    t4 = {
      onChange: inView => {
        if (!isFetching && inView) {
          fetchNextPage();
        }
      }
    };
    $[6] = fetchNextPage;
    $[7] = isFetching;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    ref
  } = useInView(t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = AuthMutation["post:/wello/v2/auth/home/donation-business-comment"]();
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== queryClient || $[11] !== toast) {
    t6 = () => {
      toast({
        message: "\uC751\uC6D0\uC774 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries();
    };
    $[10] = queryClient;
    $[11] = toast;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== toastError) {
    t7 = error => {
      toastError({
        error
      });
    };
    $[13] = toastError;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = {
      ...t5,
      onSuccess: t6,
      onError: t7
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const {
    mutate: createComment,
    isPending: createPending
  } = useMutation(t8);
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = AuthMutation["put:/wello/v2/auth/home/donation-business-comment"]();
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== queryClient || $[20] !== toast) {
    t10 = () => {
      toast({
        message: "\uC751\uC6D0\uC774 \uC218\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries();
    };
    $[19] = queryClient;
    $[20] = toast;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== toastError) {
    t11 = error_0 => {
      toastError({
        error: error_0
      });
    };
    $[22] = toastError;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = {
      ...t9,
      onSuccess: t10,
      onError: t11
    };
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const {
    mutate: updateComment,
    isPending: updatePending
  } = useMutation(t12);
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = AuthMutation["delete:/wello/v2/auth/home/donation-business-comment"]();
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== queryClient || $[29] !== toast) {
    t14 = () => {
      toast({
        message: "\uC751\uC6D0\uC774 \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries();
    };
    $[28] = queryClient;
    $[29] = toast;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== toastError) {
    t15 = error_1 => {
      toastError({
        error: error_1
      });
    };
    $[31] = toastError;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = {
      ...t13,
      onSuccess: t14,
      onError: t15
    };
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const {
    mutate: deleteComment,
    isPending: deletePending
  } = useMutation(t16);
  let t17;
  if ($[36] !== createComment || $[37] !== donationBusinessId || $[38] !== isLogin) {
    t17 = comment => {
      if (!isLogin) {
        return;
      }
      createComment({
        body: {
          comment,
          donationBusinessId
        }
      });
    };
    $[36] = createComment;
    $[37] = donationBusinessId;
    $[38] = isLogin;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const handleCreate = t17;
  let t18;
  if ($[40] !== isLogin || $[41] !== updateComment) {
    t18 = (comment_0, commentId) => {
      if (!isLogin) {
        return;
      }
      updateComment({
        body: {
          comment: comment_0,
          donationBusinessCommentId: commentId
        }
      });
    };
    $[40] = isLogin;
    $[41] = updateComment;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  const handleUpdate = t18;
  let t19;
  if ($[43] !== deleteComment || $[44] !== isLogin) {
    t19 = commentId_0 => {
      if (!isLogin) {
        return;
      }
      deleteComment({
        body: {
          donationBusinessCommentId: commentId_0
        }
      });
    };
    $[43] = deleteComment;
    $[44] = isLogin;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  const handleDelete = t19;
  let t20;
  if ($[46] !== createPending || $[47] !== data?.pages || $[48] !== deletePending || $[49] !== handleCreate || $[50] !== handleDelete || $[51] !== handleUpdate || $[52] !== hasNextPage || $[53] !== isListPending || $[54] !== isLogin || $[55] !== loginGuard || $[56] !== ref || $[57] !== updatePending) {
    const list = data?.pages.flatMap(_temp2) ?? [];
    const totalCount = data?.pages[0]?.context?.totalCount ?? 0;
    const isEmpty = totalCount < 1;
    const isGuestEmpty = isLogin === false && !isListPending && isEmpty;
    let t21;
    if ($[59] !== createPending || $[60] !== handleCreate || $[61] !== isGuestEmpty || $[62] !== isLogin || $[63] !== loginGuard) {
      t21 = isLogin === false ? <article className="flex w-full flex-col items-center gap-12 rounded-small border border-Gray-300 px-16 py-24"><p className="text-center font-400 text-Gray-550 typo-body3">{isGuestEmpty ? <>아직 등록된 응원이 없어요.<br />로그인하고 첫 응원을 남겨보세요.</> : "\uB85C\uADF8\uC778\uD558\uBA74 \uC751\uC6D0\uC744 \uB0A8\uAE38 \uC218 \uC788\uC5B4\uC694"}</p><Button dimensions="H40" roundness="capsule" onClick={loginGuard}>로그인하고 응원 남기기</Button></article> : <CommentForm onSubmit={handleCreate} loading={createPending} />;
      $[59] = createPending;
      $[60] = handleCreate;
      $[61] = isGuestEmpty;
      $[62] = isLogin;
      $[63] = loginGuard;
      $[64] = t21;
    } else {
      t21 = $[64];
    }
    t20 = <section className="flex flex-col px-16 pt-16">{t21}{isListPending ? <div className="flex justify-center py-40"><Spinner /></div> : isEmpty ? !isGuestEmpty && <div className="py-40 text-center font-400 text-Gray-550 typo-body3">아직 등록된 응원이 없어요.<br />첫 번째 응원자가 되어보세요.</div> : <><p className="w-full pb-16 pt-24 font-600 text-Gray-900 typo-body3">총{" "}<span className="text-B-500">{totalCount?.toLocaleString()}</span>개의 응원하기</p><ul className="flex flex-col">{list.map(t22 => {
            const {
              donationBusinessCommentId: donation_business_comment_id,
              profileUrl: profile_url,
              daysAgo: days_ago,
              comment: comment_1,
              mineYN: mine_yn,
              nickname,
              donationAmount: donation_amount
            } = t22;
            return <li key={donation_business_comment_id}><Comment profileUrl={profile_url} nickname={nickname} daysAgo={days_ago} mineYN={mine_yn} donationAmount={donation_amount} comment={comment_1} commentId={donation_business_comment_id} onUpdate={handleUpdate} onDelete={handleDelete} loading={updatePending || deletePending} /></li>;
          })}</ul>{hasNextPage ? <div className="my-30 w-full flex-center" ref={ref}><Spinner /></div> : null}</>}</section>;
    $[46] = createPending;
    $[47] = data?.pages;
    $[48] = deletePending;
    $[49] = handleCreate;
    $[50] = handleDelete;
    $[51] = handleUpdate;
    $[52] = hasNextPage;
    $[53] = isListPending;
    $[54] = isLogin;
    $[55] = loginGuard;
    $[56] = ref;
    $[57] = updatePending;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  return t20;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(page) {
  return page?.context?.contents ?? [];
}